import { useId } from "react";
import { useFormContext } from "react-hook-form";
import { SUBSCRIPTION_CONTRACT_META_KEY } from "@cappelendamm/e-commerce-services";
import { CheckoutForm } from "@/checkout/types";
import { InputField } from "@/forms/InputField";
import {
  validateChildBirthdayDay,
  validateChildBirthdayMonth,
  validateChildBirthdayYear,
} from "@/checkout/Sections/ChildInformationSection/validateChildBirthdate";

export type ChildBirthDateFieldsProps = {
  isPending?: boolean;
};

export const ChildBirthDateFields = ({
  isPending = false,
}: ChildBirthDateFieldsProps) => {
  const childBirthDateLabelId = useId();

  const {
    register,
    formState: { errors },
  } = useFormContext<CheckoutForm>();

  const error = errors.meta?.[SUBSCRIPTION_CONTRACT_META_KEY.CHILD_BIRTH_DATE];

  return (
    <div className="grid gap-1">
      <label id={childBirthDateLabelId}>Barnets fødselsdato</label>
      <div
        className="flex gap-3"
        role="group"
        aria-labelledby={childBirthDateLabelId}
      >
        <InputField
          className="w-16"
          name={
            `meta.${SUBSCRIPTION_CONTRACT_META_KEY.CHILD_BIRTH_DATE}.day` as const
          }
          register={register}
          type="number"
          inputMode="numeric"
          validate={validateChildBirthdayDay}
          disabled={isPending}
          placeholder="Dag"
          inputProps={{ "aria-label": "Dag" }}
        />

        <InputField
          className="w-20"
          name={
            `meta.${SUBSCRIPTION_CONTRACT_META_KEY.CHILD_BIRTH_DATE}.month` as const
          }
          register={register}
          type="number"
          inputMode="numeric"
          validate={validateChildBirthdayMonth}
          disabled={isPending}
          placeholder="Måned"
          inputProps={{ "aria-label": "Måned" }}
        />

        <InputField
          className="w-[5.6rem]"
          name={
            `meta.${SUBSCRIPTION_CONTRACT_META_KEY.CHILD_BIRTH_DATE}.year` as const
          }
          placeholder="År"
          register={register}
          type="number"
          inputMode="numeric"
          validate={validateChildBirthdayYear}
          disabled={isPending}
          inputProps={{ "aria-label": "År" }}
        />
      </div>

      {(error?.day?.message ||
        error?.month?.message ||
        error?.year?.message) && (
        <span className="text-base text-status-error-500">
          {error.day?.message || error.month?.message || error.year?.message}
        </span>
      )}
    </div>
  );
};
